export default {
    root: {
        padding: 0,
        paddingTop: 20,
    },
};
